import React, { useState, useContext } from "react"
import Modal from "../../../components/Modal"
import { Mutation } from "react-apollo"
import gql from "graphql-tag"
import AppContext from "../../../shared/AppContext"

const SEND_OBSERVATORY_BUNDLE_REQUEST = gql`
  mutation SendObservatoryBundleRequest($bundleName: String!) {
    sendObservatoryBundleRequest(bundleName: $bundleName) {
      success
    }
  }
`

const UpsellModal = (props) => {
  const { isOpen, title, setIsUpsellModalOpen } = props
  const [isSuccessfullyRequested, setSuccessfullyRequested] = useState(false)
  const { trackEvent } = useContext(AppContext)

  return (
    <Modal
      className="market-array-bundle-modal"
      isOpen={isOpen}
      closeIcon={true}
      close={() => setIsUpsellModalOpen(false)}
    >
      <>
        <div className="modal-title">Observatory Bundle Inquiry</div>
        <div>
          <div className="product-title">{title}</div>
          {isSuccessfullyRequested ? (
            <>
              <p className="modal-text">
                Thank you for submitting your request. A member of our staff
                will be in touch with you promptly to assist you further.
              </p>

              <div className="modal-buttons">
                <button
                  className="button-group-confirmation-close"
                  onClick={() => {
                    setIsUpsellModalOpen(false)
                    setSuccessfullyRequested(false)

                    trackEvent("Market array bundle upsell modal", {
                      modal_page: "request success",
                      event: "close",
                      bundle_name: title,
                    })
                  }}
                >
                  Close
                </button>
              </div>
            </>
          ) : (
            <>
              <p className="modal-text">
                Sorry, you do not have access to this report/model. Interested
                in gaining access? Request for more details from one of our
                representatives.
              </p>

              <div className="modal-buttons">
                <button
                  className="button-group-close"
                  onClick={() => {
                    setIsUpsellModalOpen(false)

                    trackEvent("Market array bundle upsell modal", {
                      modal_page: "request confirmation",
                      click_event: "close",
                      bundle_name: title,
                    })
                  }}
                >
                  Not interested
                </button>

                <Mutation mutation={SEND_OBSERVATORY_BUNDLE_REQUEST}>
                  {(sendObservatoryBundleRequest) => (
                    <button
                      className="button-group-confirm"
                      onClick={async () => {
                        const { data } = await sendObservatoryBundleRequest({
                          variables: { bundleName: title },
                        })

                        if (
                          data &&
                          data.sendObservatoryBundleRequest &&
                          data.sendObservatoryBundleRequest.success
                        ) {
                          setSuccessfullyRequested(true)

                          trackEvent("Market array bundle upsell modal", {
                            modal_page: "request confirmation",
                            click_event: "Yes, I am interested",
                            bundle_name: title,
                          })
                        }
                      }}
                    >
                      Yes, I am interested!
                    </button>
                  )}
                </Mutation>
              </div>
            </>
          )}
        </div>
      </>
    </Modal>
  )
}

export default UpsellModal
